import { useEffect } from 'react';

const STORAGE_KEY = 'vdk-public-theme';

/**
 * Public pages stay on Espresso + Cream. Dark is parked and can be restored later.
 */
const usePublicTheme = () => {
  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, 'light');
    document.documentElement.dataset.publicTheme = 'light';
    document.body.style.background = '#F5F0E7';

    return () => {
      delete document.documentElement.dataset.publicTheme;
      document.body.style.background = '';
    };
  }, []);

  return { theme: 'light' };
};

export default usePublicTheme;
